/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import type React from 'react';
import { componentWithCondition } from '@jira/platform__utils-feature-flagging-utils/src/utils/component-with-condition/index.tsx';
import { expVal } from '@atlassian/jira-feature-experiments';
import { JiraSpaPageContainer } from './JiraSpaPageContainer.tsx';
import { JiraSpaPageContainerOld } from './JiraSpaPageContainerOld.tsx';
import type { PageContainerProps } from './types.tsx';

export const PageContainer: React.FC<PageContainerProps> = componentWithCondition(
	() => expVal('jpx-463-component-refactor', 'isEnabled', false),
	JiraSpaPageContainer,
	JiraSpaPageContainerOld,
);
